"use strict";

window.legacy = 'legacy/';